import React from "react";
import { Award, Stamp, FileCheck, ShieldCheck } from "lucide-react";

const CERTS = [
  { icon: Award, title: "IRS Certified", subtitle: "Tax Preparer" },
  { icon: Stamp, title: "Notary Public", subtitle: "Estado de Florida" },
  { icon: FileCheck, title: "CAA", subtitle: "Certifying Acceptance Agent" },
  { icon: ShieldCheck, title: "Servicio Autorizado", subtitle: "Verificado y confiable" },
];

export default function Certifications() {
  return (
    <section className="py-14 bg-[#0f172a] text-white relative overflow-hidden" data-testid="certifications-section">
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] opacity-90"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-10 reveal">
          <div className="text-xs font-semibold text-[#C89B2C] tracking-[0.2em] uppercase mb-2">
            Certificaciones y credenciales
          </div>
          <h3 className="font-display text-2xl lg:text-3xl font-bold">
            Certificados y autorizados para servirte
          </h3>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {CERTS.map((c, i) => (
            <div
              key={c.title}
              className="reveal flex items-center gap-4 border border-white/10 bg-white/5 backdrop-blur-sm p-5 rounded-sm hover:border-[#C89B2C]/50 transition-colors"
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`cert-${i}`}
            >
              <div className="w-12 h-12 rounded-sm bg-[#C89B2C] flex items-center justify-center flex-shrink-0">
                <c.icon className="text-[#0f172a]" size={22} strokeWidth={1.75} />
              </div>
              <div>
                <div className="font-display font-semibold text-white text-sm sm:text-base">{c.title}</div>
                <div className="text-xs text-white/60">{c.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
